import {Chip, IconButton, Tooltip, Typography} from "@material-tailwind/react";
import {PencilIcon} from "@heroicons/react/24/solid";
import {BsListUl} from "react-icons/bs";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import React, {useContext, useState} from "react";
import {TableHead} from "../system/thead";
import {PaginateContext} from "../../context/paginate";
import {WithdrawalSourcesModal} from "./sources_modal";


const TABLE_HEAD = ["#", "مبلغ", "توضیحات", "وضعیت", "زمان", "عملیات"];

export function UserWithdrawalGrid({
                                     withdrawals,
                                     setModalOpen,
                                     setSelectedRow,
                                   }) {

  const [selectedHead, setSelectedHead] = useState("#")
  const [sourcesModalOpen, setSourcesModalOpen] = useState(false);
  const [selectedWithdrawalSources, setSelectedWithdrawalSources] = useState(null);

  const {
    setSortBy,
    sortType,
    setSortType,
  } = useContext(PaginateContext)

  const headMap = {
    "#": "",
    "مبلغ": "value",
    "توضیحات": "description",
    "وضعیت": "status",
    "زمان": "created_at",
    "عملیات": "",
  }

  const headSortable = {
    "#": false,
    "مبلغ": true,
    "توضیحات": true,
    "وضعیت": true,
    "زمان": true,
    "عملیات": false,
  }

  return (
    <div>
      {sourcesModalOpen && (
        <WithdrawalSourcesModal
          withdrawal={selectedWithdrawalSources}
          open={sourcesModalOpen}
          setOpen={setSourcesModalOpen}
          showPrintButton={false}
        />
      )}
      <table className="mt-4 text-left w-full">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter">
        {withdrawals.length > 0 && withdrawals.map(
          ({id, value, description, status, created_at, sources}, index) => {
            const isLast = index === withdrawals.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={id}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(value, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {description}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center ">
                    {
                      <Chip
                        value={status === "accepted" ? "انجام شده" : status === "new" ? "در انتظار بررسی" : status === "rejected" ? "رد شده" : status === "canceled" ? "لغو شده" : status}
                        color={status === "accepted" ? "green" : status === "new" ? "amber" : status === "rejected" ? "red" : "red"}
                      />
                    }
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(created_at.split(" ")[1]) + " " + persianNumberFormat(created_at.split(" ")[0])}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex items-center justify-center gap-1">
                    <Tooltip content="منابع">
                      <IconButton
                        variant="text"
                        className="text-align=right"
                        disabled={!sources || sources.length === 0}
                        onClick={() => {
                          setSelectedWithdrawalSources(withdrawals[index]);
                          setSourcesModalOpen(true);
                        }}
                      >
                        <BsListUl className="h-4 w-4"/>
                      </IconButton>
                    </Tooltip>
                    <Tooltip content="مشاهده">
                      <IconButton variant="text" className="text-align=right" onClick={() => {
                        setSelectedRow(withdrawals[index]);
                        setModalOpen(true);
                      }}>
                        <PencilIcon className="h-4 w-4"/>
                      </IconButton>
                    </Tooltip>
                  </div>
                </td>

              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}
